import { keyframes } from 'styled-components';

export const animaIn = keyframes`
  from { opacity: 0.5; transform: scale(0.5); }
  to { opacity: 1; transform: scale(1); }
`;

export const animaDash = keyframes`
  to {
      stroke-dashoffset: 0;
    }
`;

export const animaFadeIn = keyframes`
  from { opacity: 0;}
  to { opacity: 1;}
`;

export const animaFadeOut = keyframes`
  from { opacity: 1;}
  to { opacity: 0;}
`;

export const animaInToLeft = keyframes`
  from { opacity: 0; transform: translateX(20px); }
  to { opacity: 1;  transform: translateX(0px);}
`;

export const animaInToRight = keyframes`
  from { opacity: 0; transform: translateX(-20px); }
  to { opacity: 1;  transform: translateX(0px);}
`;

export const animaFadeScaleIn = (startScale = 0.7) => keyframes`
  from { opacity: 0; transform: scale(${startScale});}
  to { opacity: 1; transform: scale(1);}
`;

export const rotate = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

export const animaUpAndDown = keyframes`
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
`;

export const scaleInAndOut = keyframes`
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.8);
  }
`;

export const DownFadeIn = keyframes`
    from { 
      opacity: 0.6;
      transform: translateY(-8px);
    }
    to { 
      opacity: 1;
      transform: translateY(0);
    }
`;

export const BounceToLeft = keyframes`
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-4px);
  }
`;

export const animaJelloHorizontal = keyframes`
  0% {
    transform: scale3d(0.75, 1, 1);
  }
  50% {
    transform: scale3d(1.25, 1, 1);
  }
  100% {
    transform: scale3d(1, 1, 1);
  }
`;

export const animaCircle = keyframes`
  0%, 100% {
    transform: rotate(-4deg);
  }
  50% {
    transform: rotate(2deg);

  }
`;

export const animaFadeInAndOut = keyframes`
  0%, 100% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
`;

export const moveRightTop = keyframes`
  0%, 8%, 16%, 24% {
    transform: translate(0, 0);
  }
  4%, 12%, 20% {
    transform: translate(8px, -8px);
  }
`;

export const moveRightBottom = keyframes`
  0%, 8%, 16%, 24% {
    transform: translate(0, -0);
  }
  4%, 12%, 20% {
    transform: translate(8px, 8px);
  }
`;

export const moveLeftTop = keyframes`
  0%, 8%, 16%, 24% {
    transform: translate(0, 0);
  }
  4%, 12%, 20% {
    transform: translate(-8px, -8px);
  }
`;

export const moveLeftBottom = keyframes`
  0%, 8%, 16%, 24% {
    transform: translate(0, 0);
  }
  4%, 12%, 20% {
    transform: translate(-8px, 8px);
  }
`;

export const moveUp = keyframes`
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-70px);
  }
`;

export const shake = keyframes`
  0% { transform: translate(1px, 1px) rotate(0deg); }
  10% { transform: translate(-1px, -1px) rotate(-1deg); }
  20% { transform: translate(-1px, 0px) rotate(1deg); }
  30% { transform: translate(1px, 1px) rotate(0deg); }
  40% { transform: translate(1px, -1px) rotate(1deg); }
  50% { transform: translate(-1px, 1px) rotate(-1deg); }
  60% { transform: translate(-1px, 1px) rotate(0deg); }
  70% { transform: translate(1px, 1px) rotate(-1deg); }
  80% { transform: translate(-1px, -1px) rotate(1deg); }
  90% { transform: translate(1px, 1px) rotate(0deg); }
  100% { transform: translate(1px, -1px) rotate(-1deg); }
`;
